import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";

import { MemoizedLeadCaptureMainV2 } from "../../modules/Lead Capture/VehicleData/VehicleDataV2";
import { sendAnalytics } from "../../utils/analyticsCommon";

const LeadCaptureV2 = ({ vehicleDataLocal }) => {
  const [vehicleData, setVehicleData] = useState(vehicleDataLocal[0]);
  useEffect(() => {
    if (vehicleData?.name?.length > 0) {
      let payload = {
        screen_name: "vehicle booking",
        vehicle_id: vehicleData?.vehicle_id,
        vehicle_name: vehicleData?.name,
      };
      sendAnalytics("screen_viewed", payload, "en");
    }
    // eslint-disable-next-line
  }, [vehicleData]);

  return (
    <Box>
      <MemoizedLeadCaptureMainV2 vehicleData={vehicleData} />
    </Box>
  );
};
// export default LeadCapture;
export const MemoizedLeadCaptureV2 = React.memo(LeadCaptureV2);
